export default __webpack_public_path__ + "static/why-ml-3-2f2de292aa7a719b0da2fa00cccfb933.webp";